<template>
  <dashboard-layout>
    <CCard class="p-4">
      <heading
        title="My Past Orders"
        description="There are 14 products in current orders"
      />

      <div class="mb-4">
        <CRow class="align-items-end">
          <CCol md="4">
            <label>Start Date</label>
            <datepicker v-model="date" />
          </CCol>
          <CCol md="4">
            <label>End Date</label>
            <datepicker v-model="date" />
          </CCol>
          <CCol md="4">
            <button class="btn btn-primary">Filter</button>
          </CCol>
        </CRow>
      </div>

      <div>
        <table class="table orders-listing">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Item</th>
              <th scope="col">Qty</th>
              <th scope="col">Amount</th>
              <th scope="col">Date</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in ordersData" :key="item.id">
              <th>{{ item.id }}</th>
              <td>
                <div class="d-flex" style="max-width: 200px">
                  <div class="me-3">
                    <img :src="item.image" alt="" />
                  </div>
                  <div>
                    {{ item.name }}
                  </div>
                </div>
              </td>
              <td>{{ item.qty }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.status }}</td>
              <td>
                <router-link :to="'/dashboard/return/' + item.id"
                  >Return</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CCard>
  </dashboard-layout>
</template>

<script>
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import Heading from "@/components/shared-components/heading/Heading.vue";
import Datepicker from "vue3-datepicker";
export default {
  name: "PastOrders",
  components: { DashboardLayout, Heading, Datepicker },

  data() {
    return {
      date: new Date(),
      ordersData: [
        {
          id: "58921",
          name: "LS2 Stream Evo Tacho – Gloss White Black Red",
          qty: 2,
          amount: "Rs. 4500",
          status: "Delivered",
          date: "27/03/2022",
          image: "/img/helmets/helmet01.png",
        },
        {
          id: "56421",
          name: "LS2 Stream Black Red",
          qty: 2,
          amount: "Rs. 4500",
          status: "Delivered",
          date: "27/03/2022",
          image: "/img/helmets/helmet02.png",
        },
        {
          id: "50621",
          name: "Gloss White Black Red",
          qty: 2,
          amount: "Rs. 4500",
          status: "Delivered",
          date: "27/03/2022",
          image: "/img/helmets/helmet03.png",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
